import { RequestForm } from './request-form.component';

export * from './request-form.component';
export default RequestForm;

if (!customElements.get('der-tm-appointment-booking-request-form')) {
    customElements.define('der-tm-appointment-booking-request-form', RequestForm);
}
